<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button-text">
            <ion-label class="ion-text-left ion-text-wrap" color="primary"> {{ 'processes.processes' | translate }} </ion-label>
        </ion-item>

        <ion-searchbar
            mode="ios"
            class="section-search-custom ion-margin-top ion-margin-bottom"
            [placeholder]="'processes.searchPlaceholder' | translate"
            (keyup)="updateSearch($event.target.value)"
        >
        </ion-searchbar>

        <ng-container *ngFor="let processType of processTypeKeys">
            <ion-list mode="ios" lines="full" class="progresses-list" *ngIf="!processAvailability?.process[processType]?.hidden">
                <ion-item header lines="none">
                    <ion-label class="ion-text-center ion-text-wrap"> {{ processAvailability.process[processType].title | translate | uppercase }} </ion-label>
                    <ion-button slot="end" mode="ios" color="primary" (click)="goToManageVersion({ type: processType })"> {{ 'processes.newVersion' | translate }} </ion-button>
                </ion-item>

                <app-version-preview
                    *ngFor="let version of displayedProcesses[ processType ]"
                    [version]="version"
                    (manageVersion)="goToManageVersion($event)"
                    (deleteVersion)="confirmDeleteProcess($event)"
                    (cloneVersion)="cloneProcess($event)"
                ></app-version-preview>
            </ion-list>
        </ng-container>
    </div>
</ion-content>
